@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.linkshare
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.linkshare.TopLinkDto
import com.narbase.letsgo.web.models.linkshare.LinkShareDateRange
import com.narbase.letsgo.web.models.linkshare.TopLinksSortBy

object GetLinkShareTopLinksEndpoint : EndPoint<GetLinkShareTopLinksEndpoint.Request, GetLinkShareTopLinksEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        @Suppress("NON_EXPORTABLE_TYPE") val sortBy: DtoName<TopLinksSortBy>,
        @Suppress("NON_EXPORTABLE_TYPE") val dateRange: DtoName<LinkShareDateRange>,
        val customFrom: KmmLong?,
        val customTo: KmmLong?,
    )

    class Response(
        val list: Array<TopLinkDto>,
        val total: Int,
    )
}
